// extracted by mini-css-extract-plugin
export default {"button":"Buttons_button__XPqKc","icon":"Buttons_icon__0Xvv4"};